import job from './Job';

export default {
    job
};
